import React from 'react'

function Contact() {
  return (
    <div className='ml-[300px]'>
      Contact
    </div>
  )
}

export default Contact
